import { StateCreator } from 'zustand';

import { IErrorStore } from './types';

export const errorSlice: StateCreator<IErrorStore, [], [], IErrorStore> = (set) => ({
  errorType: null,
  changeErrorType: (errorType) => set({ errorType }),
});
